import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/css";
import { theme } from "../../theme";
import { Box } from "../../box";
import { Text } from "../../text";
export const ProgressBar = ({ progress, total, completed }) => (_jsxs("div", { className: s.container, children: [_jsxs(Box, { flexDirection: "row", justifyContent: "space-between", className: s.header, children: [_jsx(Text, { fontSize: "1.25em", className: s.progressText, children: "Progress" }), _jsxs(Text, { color: "darkBlue60", fontSize: "1.25em", className: s.progressValues, children: [progress, "% - ", completed, " out of ", total, " pages"] })] }), _jsx("div", { className: s.progressBarContainer, children: _jsx("div", { className: s.progressBar, style: {
                    width: `${progress}%`,
                } }) })] }));
const s = {
    container: css `
    margin-bottom: 40px;
  `,
    header: css `
    padding: 0 2px 15px 2px;
    font-weight: bold;
  `,
    progressBarContainer: css `
    width: 100%;
    height: 6px;
    border-radius: 3px;
    background-color: #dcdada;
  `,
    progressText: css `
    margin-right: 1em;
  `,
    progressValues: css `
    text-align: right;
  `,
    progressBar: css `
    height: 6px;
    border-radius: 3px;
    background-color: ${theme.color.primary};
  `,
};
